import { render, staticRenderFns } from "./competitor-price-ignore.vue?vue&type=template&id=22deb201&scoped=true"
import script from "./competitor-price-ignore.vue?vue&type=script&lang=js"
export * from "./competitor-price-ignore.vue?vue&type=script&lang=js"
import style0 from "./competitor-price-ignore.vue?vue&type=style&index=0&id=22deb201&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22deb201",
  null
  
)

export default component.exports